/*
 * Package Import
 */
import { toast } from 'react-toastify';

/*
 * Local Import
 */
import { api, Payload } from 'src/utils/api';
import { API_DEACTIVATE_USER, API_PATCH } from 'src/constants/apiRoutes';

/*
 * Code
 */
export const deactivateUser = async (userId: string): Promise<void> => {
  try {
    const payload: Payload = {
      method: API_PATCH,
      url: API_DEACTIVATE_USER,
      data: {
        _id: userId,
      },
    };

    await api(payload);
  }
  catch (error) {
    toast(`Erreur pendant l'archivage : ${error}`, { type: 'error' });
    throw error;
  }
};
